import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DirectService } from '@app/modules/direct/services/direct.service';
import { DomainsService, ListDomain } from '@app/modules/domains/domains.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { combineLatest, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Component({
  selector: 'sbnb-domains-list',
  templateUrl: './domains-list.component.html',
})
export class DomainsListComponent implements OnInit {
  domains: (ListDomain & { siteName?: string })[] = [];
  loading = true;

  constructor(
    private router: Router,
    private domainsService: DomainsService,
    private directService: DirectService,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit(): void {
    this.loadDomains();
  }

  loadDomains(): void {
    this.loading = true;

    combineLatest([this.domainsService.listDomains(), this.directService.getSites()]).pipe(
      map(([domains, sites]) => {
        const siteMap = new Map<string, string>();
        sites.forEach((site) => siteMap.set(site.id, site.name));

        return domains.map((domain) => ({
          ...domain,
          siteName: domain.siteId ? siteMap.get(domain.siteId) : undefined,
        }));
      }),
      finalize(() => (this.loading = false)),
      catchError((error) => {
        console.error('Failed to load domains or sites:', error);
        this.toast.error(error.message || 'Failed to load domains. Please try again.');
        return of([]);
      })
    ).subscribe((response) => {
      this.domains = response;
    });
  }

  addNewDomain(): void {
    this.router.navigate(['/settings/domains/new']);
  }
}
